import { useTranslation } from 'react-i18next';
import useScrollReveal from '@/hooks/useScrollReveal';

export default function AboutSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="nosotros" className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      {/* Greek decorative */}
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <div className="absolute right-0 top-0 bottom-0 w-1/3 opacity-[0.04]">
          <div className="absolute right-10 top-10 w-px h-64 bg-primary-400"></div>
          <div className="absolute right-20 top-16 w-px h-48 bg-primary-400"></div>
          <div className="absolute right-10 top-16 w-10 h-px bg-primary-400"></div>
        </div>
        {/* Arches */}
        <div className="absolute left-0 bottom-0 opacity-[0.05]">
          <div className="w-48 h-64 border border-primary-400 rounded-t-full"></div>
          <div className="w-40 h-56 border border-primary-400 rounded-t-full ml-20 -mt-52"></div>
        </div>
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left image */}
          <div ref={ref} className={`flex-1 scroll-reveal ${isVisible ? 'visible' : ''}`}>
            <div className="relative w-full max-w-[500px] mx-auto aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/7457165c-176b-4bb4-a41c-5aebca155c44/affacc26-ea1b-42ea-a6ab-f0e85a9cf136_compressed_Nosotros.webp"
                alt="Kremsi Yogurt Griego - presentaciones 950g, 440g y 130g"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/20 to-transparent"></div>
            </div>
          </div>

          {/* Right content */}
          <div className="flex-1">
            <div className={`scroll-reveal ${isVisible ? 'visible' : ''}`} style={{ transitionDelay: '150ms' }}>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-6">
                {t('about.title')}
              </h2>
              <p className="text-lg md:text-xl text-foreground-600 mb-6 font-heading italic">
                {t('about.subtitle')}
              </p>
              <div className="space-y-5">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {t('about.paragraph1')}
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {t('about.paragraph2')}
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {t('about.paragraph3')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}